// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChooseLayout_wrapper__1lqrk","squares":"ChooseLayout_squares__3ffSF","select":"ChooseLayout_select__e_Oq2"};